import React, { useEffect, useState } from "react";

const relations = [
  "Son",
  "Daughter",
  "Brother",
  "Sister",
  "Relative",
  "Friend",
  "Self",
];

const ProfileData = [
  { name: "First Name", key: "first_name" },
  { name: "Last Name", key: "last_name" },
  { name: "Middle Name", key: "middle_name" },
  { name: "Gotram", key: "gothram" },
  { name: "Occupation", key: "occupation" },
  { name: "Email Address", key: "email" },
];

export default function ViewBatAccordion({ profileData }) {
  const [userDetails, setUserDetails] = useState();

  useEffect(() => {
    setUserDetails(profileData);
  }, []);

  return (
    <React.Fragment>
      <div className="d-flex justify-content-center">
        {userDetails && (
          <div className="view-profile-card mb-5 mt-5 toggle-profile-data-grid-responive-card">
            <div className="toggle-profile-data-grid-responive">
              {ProfileData?.map((item, index) => (
                <p key={index}>
                  <span className="key mr-10">{item?.name}:</span>
                  <span>{userDetails[item?.key] ?userDetails[item?.key]: "N/A"}</span>
                </p>
              ))}
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
